import { CookieHelper } from "../../Common/CookieHelper";
import { GlobalData } from "../../Common/GlobalData";
import { Notification, TemplateHelpers } from "../../Common/KendoHelpers";
import { StockPickList } from "../../Common/StockPickList";

export class StockChecklist {
    public static readonly GRID = '#grid';
    public static readonly MARKET_PCT = '#marketPct';
    public static readonly FUNDAMENTAL_PCT = '#fundamentalPct';
    public static readonly TECHNICAL_PCT = '#technicalPct';
    public static readonly UPDATE_BTN = '#updateBtn';

    private stockPickList!: StockCheckListStockPickList;

    constructor(index: number) {
        this.init(index);
    }

    private init(index: number) {
        const self = this;

        this.stockPickList = new StockCheckListStockPickList(StockChecklist.GRID,
            GlobalData.URL_SUFFIX_IBD_MARKET_SMITH_STOCK_CHECKLIST, index);

        $(StockChecklist.GRID).kendoGrid({
            dataSource: new kendo.data.DataSource(this.stockPickList.getDataSourceOptions()),
            height: 915,
            groupable: false,
            editable: false,
            navigatable: false,
            sortable: true,
            filterable: true,
            pageable: false,
            resizable: true,
            dataBound: this.updateTotalRankHeader,
            columns: [
                {
                    field: 'symbol',
                    title: 'Symbol',
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getSymbolLinkTemplate('StockChecklistReport?symbol=')),
                },
                {
                    field: 'companyName',
                    title: 'Company Name',
                    width: '24%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                },
                {
                    title: 'Market',
                    width: '11%',
                    columns: [
                        {
                            field: 'marketScore',
                            title: '3<br>Composite<br>Uptrend<br>Group RS',
                            width: '11%',
                            headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                            attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                        },
                    ],
                },
                {
                    title: 'Fundamental',
                    width: '30%',
                    columns: [
                        {
                            field: 'currentEarningsScore',
                            title: '7<br><br>Current<br>Earnings',
                            width: '10%',
                            headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                            attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                        },
                        {
                            field: 'annualEarningsScore',
                            title: '3<br><br>Annual<br>Earnings',
                            width: '10%',
                            headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                            attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                        },
                        {
                            field: 'salesMarginRoeScore',
                            title: '6<br>Sales<br>Margin<br>Roe',
                            width: '10%',
                            headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                            attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                        },
                    ],
                },
                {
                    title: 'Technical',
                    width: '20%',
                    columns: [
                        {
                            field: 'priceVolumeScore',
                            title: '5<br><br>Price<br>Volume',
                            width: '10%',
                            headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                            attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                        },
                        {
                            field: 'supplyDemandScore',
                            title: '5<br><br>Supply<br>Demand',
                            width: '10%',
                            headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                            attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                        },
                    ],
                },
                {
                    title: 'Rating',
                    width: '40%',
                    columns: [
                        {
                            field: 'totalValue',
                            title: '29<br><br>Total<br>Value',
                            width: '10%',
                            headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                            attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                        },
                        {
                            field: 'totalScore',
                            title: '17.50<br><br><br>Score',
                            width: '10%',
                            headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                            attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                            format: '{0:n2}',
                        },
                        {
                            field: 'totalPct',
                            title: 'Pct %',
                            width: '10%',
                            headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                            attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                            format: '{0:p2}',
                        },
                        {
                            field: 'totalRank',
                            title: 'Total<br>Rank',
                            width: '10%',
                            headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                            attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                        },
                    ],
                },
            ]
        }).data('kendoGrid');

        $(StockChecklist.UPDATE_BTN).on('click', () => {
            self.stockPickList.updateGrid();
        });
    }

    private updateTotalRankHeader(e: any) {
        const grid = $(StockChecklist.GRID).data('kendoGrid');
        const data = grid?.dataSource.data();
        if (!grid || !data?.length) {
            return;
        }

        const column = grid.thead.find("[data-field='totalRank']");
        column.attr('data-title', 'Test<br>Title');
        const span = column.find('.k-column-title');
        span.html(data[0].count + '<br><br>Total<br>Rank');
    }
}

export class StockCheckListStockPickList extends StockPickList {
    constructor(gridId: string, apiUrl: string, index: number) {
        super(gridId, apiUrl, index);
    }

    public updateGrid(index: number | null = null) {
        if (!index) {
            index = this.dropDownTree.value();
        }

        this.setDataSourceOptions(index);
        var grid = $(this.gridId).data("kendoGrid");
        if (grid) {
            grid.setDataSource(new kendo.data.DataSource(this.dataSourceOptions));
        }
    }

    protected setDataSourceOptions(index: number | null): void {
        this.dataSourceOptions = {
            transport: {
                read: GlobalData.URL_BASE + this.apiUrl + '?index=' + index +
                    '&marketPct=' + ($(StockChecklist.MARKET_PCT) as any)[0].value +
                    '&fundamentalPct=' + ($(StockChecklist.FUNDAMENTAL_PCT) as any)[0].value +
                    '&technicalPct=' + ($(StockChecklist.TECHNICAL_PCT) as any)[0].value,
            },
            error: (e) => {
                var notification = new Notification();
                notification.error('No data found to display');
            },
        };
        CookieHelper.set(StockPickList.COOKIE, index);
    }
}
